import React, { Component } from 'react';

//view
import ContinuingPositionsHomeView from "../presentational/ContinuingPositionsHomeView";

//generic functions
import {
    isEmpty,
    cloneObject
} from "../../../../../functions/generic_functions";

//static routes
import {
    cari_api_load_home_url,
    cari_app_form_consent_url,
    cari_app_form_url
} from "../../../../../router/static_routes";


//redux
import { connect } from "react-redux";
import {
    setCariFormActivePositionData,
    setCariFormActiveApplicationData,
    resetCariActivePositionData,
    resetCariActiveApplicationData,
    resetCariUrlParamsData,
    openCariModal,
    resetCariActiveData
} from "../../../../../redux/actions/indexActions";

//redux mapper
const mapStateToProps = state => {
    return {
        activeVerifiedLoginUserData: state.cariReducer.activeVerifiedLoginUserData,
        activeUserData: state.cariReducer.activeUserData,
        activePositionData: state.cariReducer.activePositionData,
        activeUrlParamData: state.cariReducer.activeUrlParamData
    };
};
const mapDispatchToProps = dispatch => {
    return {
        setCariFormActiveApplicationData: (application_data) => {
            dispatch(setCariFormActiveApplicationData(application_data))
        },
        setCariFormActivePositionData: (position_data) => {
            dispatch(setCariFormActivePositionData(position_data))
        },
        resetCariActivePositionData: () => {
            dispatch(resetCariActivePositionData())
        },
        resetCariActiveApplicationData: () => {
            dispatch(resetCariActiveApplicationData())
        },
        resetCariActiveData: () => {
            dispatch(resetCariActiveData())
        },
        resetCariUrlParamsData: () => {
            dispatch(resetCariUrlParamsData())
        },
        openCariModal: (modal_data) => {
            dispatch(openCariModal(modal_data))
        },
    };
};


class ContinuingPositionsHomeContainer extends Component {

    state = {
        mounted: false,
        pageLoaded: false,
        staticUiData: {
            cariHomeDescrption: "Home description",
            positionList: [],
        }
    }

    constructor(props) {
        super(props);

        //load page data from apis
        this.load_page_data_from_api = this.load_page_data_from_api.bind(this);
        this.open_application = this.open_application.bind(this);

        //save active position
        this.handleSelectPosition = this.handleSelectPosition.bind(this);
    }

    componentWillMount() {
        document.title = "Academic Recruitment Home";
    }

    /*
        initializes the position list based on the user to return an application status of either: iniital, complete or not_applied for each position
        will also return all necessary information for each position

        post parameters {
            email,
            token,
        }

        return data {
            status => true/false
            message {
                cariHomeDescrption: "Home description",
                positionList: [
                    {
                        position_id,
                        position_title,
                        qualifications,
                        duties,
                        about_beedie,
                        conference,
                        open_description,
                        initial_deadline,
                        closing_deadline,
                        position_applicant_requirements,
                        application_id,
                        application_status,
                    },
                ],
            }
        }
    */
    load_page_data_from_api() {

        //get data from redux store
        var currentEmail = this.props.activeVerifiedLoginUserData.email;
        var currentToken = this.props.activeVerifiedLoginUserData.token;

        var form_data = new FormData();
        form_data.append("email", currentEmail);
        form_data.append("token", currentToken);

        var post_data = {
            "email": currentEmail,
            "token": currentToken
        }

        //fetch page data from parameters
        fetch(cari_api_load_home_url, {
            method: 'POST',
            body: form_data,
            headers: {
                'Accept': 'application/json',
            }
        }).then((response) => {
            var responseHttpCode = response.status;

            //only continue fetch if mounted
            if (this.state.mounted) {
                //good request
                if (responseHttpCode === 200) {
        
                }
                //404 api not found, allows user to retry
                else if (responseHttpCode === 404) {
                    this.props.openCariModal({
                        modalId: "errorModal",
                        title: "Bad Request, please try again.",
                    });
                }
                //invalid data and not authorized, reset cari data
                else {
                    this.props.openCariModal({
                        modalId: "errorModal",
                        title: "User Session is invalid or has expired, please login again.",
                        callBackFuncOnOk: () => {
                            this.props.resetCariActiveData();
                        }
                    });
                }
                return response.json();
            }
        })
        .then(json => {
            //successfully processed request
            if (!isEmpty(json)
                && !isEmpty(json.status)
                && json.status 
                && !isEmpty(JSON.parse(json.message).cariHomeDescription)
                && !isEmpty(JSON.parse(json.message).positionList)
            ) {
                var json_data = JSON.parse(json.message);
                var fetchedPageData = json_data;

                //init copy of post data of local state
                var copyStaticUiData = cloneObject(this.state.staticUiData);    

                //loop through fetched page data and set the state values 
                copyStaticUiData = fetchedPageData;
                
                //set page loaded to true
                this.setState({
                    pageLoaded: true,
                    staticUiData: copyStaticUiData
                });

                this.open_application();
            }
            //if api returns no data, popup modal 
            else {
                console.log("Failed to retrieve data, please try again.");
            }
        })
        //if api is not found
        .catch((error) => {
            console.log(error);
        });
    }

    // Check if there is an application to load.
    // This will only do something if url params were passed in from an external link. (probably from https://beedie.sfu.ca/about/work-for-us)
    open_application() {
        // Check if position and url param data is set. It only will be if url params were passed in.
        if (!isEmpty(this.props.activePositionData)
            && !isEmpty(this.props.activePositionData.position_id)
            && !isEmpty(this.props.activePositionData.position_title)
            && !isEmpty(this.props.activeUrlParamData)
            && !isEmpty(this.props.activeUrlParamData.url_params_set)) {

            // Reset the url param data so that routing goes back to normal after this initial route to the requested application.
            this.props.resetCariUrlParamsData();

            // Check if the application we are opening is already in progress.
            var positionId = this.props.activePositionData.position_id;
            var positionListArray = this.state.staticUiData['positionList'];

            var applicationId = '';
            var applicationStatus = '';

            for (var i = 0; i < positionListArray.length; i++) {
                if (positionListArray[i]['position_id'] == positionId) {
                    applicationId = positionListArray[i]['application_id'];
                    applicationStatus = positionListArray[i]['application_status'];

                    break;
                }
            }

            // If application id exists, save it as active application data.
            if(!isEmpty(applicationId)) {
                this.props.setCariFormActiveApplicationData({ "application_id": applicationId, "application_status": applicationStatus});
            }

            // If application has no status load consent page.
            if (isEmpty(applicationStatus)) {
                //redirect to the consent page of the new application
                this.props.history.push(cari_app_form_consent_url);
            }
            // Application exists.
            else {
                // Redirect to a page using javascript with withRouter instead of navlink for single page load.
                var cari_form_page = cari_app_form_url + "/" + ((applicationStatus.toLowerCase() === "complete") ? 3 : 1);
                this.props.history.push(cari_form_page);
            }
        }
    }

    componentDidMount() {
        this.setState({
            mounted: true
        }, () => {
            this.load_page_data_from_api();
        })
    }

    componentWillUnmount() {
        this.setState({
            mounted: false
        });
    }


    /*
        saves the selected position and application as the currently active position with redux
    */
    handleSelectPosition(positionId, positionTitle, applicationId, applicationStatus) {

        //reset active application data and position data
        this.props.resetCariActivePositionData();
        this.props.resetCariActiveApplicationData();

        //if application id exists, save it as active application data
        if(!isEmpty(applicationId)) {
            this.props.setCariFormActiveApplicationData({ "application_id": applicationId, "application_status": applicationStatus});
        }
        //set active position
        this.props.setCariFormActivePositionData({ "position_id": positionId, "position_title": positionTitle });
    }

    render() {
        return (
            <div>
                <ContinuingPositionsHomeView
                    pageLoaded={this.state.pageLoaded}
                    staticUiData={this.state.staticUiData}
                    selectPositionFunc={this.handleSelectPosition}
                />
            </div>
        );
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(ContinuingPositionsHomeContainer);